import { Temporal } from "temporal-polyfill-lite";
/** Safely deserializes an optional UTC timestamp. */ export function deserializeRecurrenceUtcDateTime(value) {
    if (value == null) {
        return null;
    }
    if (typeof value === "string") {
        try {
            return Temporal.Instant.from(value);
        } catch  {
            return null;
        }
    }
    return null;
}
/** Serializes an optional Temporal Instant, preserving undefined for omission and null for explicit clears. */ export function serializeRecurrenceUtcDateTime(value) {
    return value == null ? value : value.toString();
}
